import _ from 'lodash';
import { getNomeSobrenome } from './getNomeSobrenome';

function getDadosGraficoNetwork(unidades) {
  const dados = [];
  unidades.forEach((u) => {
    dados.push(...u.subunidades.map((su) => ({ unidadePai: u, subunidade: su })));
  });
  const unidadesNos = _.uniq(_.flatten(dados.map((d) => [d.unidadePai.id, d.subunidade.id])));
  const nos = [];

  for (let i = 0; i < unidadesNos.length; i += 1) {
    let dadosUnidade = dados.find((d) => d.subunidade.id === unidadesNos[i]);
    let unidade;

    if (!dadosUnidade) {
      dadosUnidade = dados.find((d) => d.unidadePai.id === unidadesNos[i]);
      unidade = dadosUnidade.unidadePai;
    } else {
      unidade = dadosUnidade.subunidade;
    }

    nos.push([
      unidade,
      _.countBy(dados, (d) => d.unidadePai.id === unidadesNos[i]).true,
      _.countBy(dados, (d) => d.subunidade.id === unidadesNos[i]).true,
    ]);
  }

  return {
    network: {
      dados: dados.map((d) => [
        d.unidadePai.sigla + d.unidadePai.id,
        d.subunidade.sigla + d.subunidade.id,
      ]),
      nos: nos.map((n) => ({
        id: n[0].sigla + n[0].id,
        name: n[0].sigla,
        color: n[2] === undefined ? '#2D5269' : '#348ECA',
        marker: { radius: n[2] === undefined ? 30 : 22 },
        info: `<span style="color:#2D5269;font-weight:bold">${
          n[0].nome} (${n[0].sigla})</span><br/>`
          + `<span style="color:#348ECA;font-weight:bold">GESTOR:</span> ${
            n[0].gestor ? getNomeSobrenome(n[0].gestor.nome) : 'N/D'}<br/>`
          + `<span style="color:#348ECA;font-weight:bold">FUNÇÃO:</span> ${
            n[0].gestor ? n[0].gestor.funcao ? n[0].gestor.funcao : 'N/D' : 'N/D'}<br/>`
          + `<span style="color:#348ECA;font-weight:bold">CARGO:</span> ${
            n[0].gestor ? n[0].gestor.cargo ? n[0].gestor.cargo : 'N/D' : 'N/D'}<br/>`
          + `${n[0].gestorSubstituto ? `<span style="color:#00ABA4;font-weight:bold">GESTOR SUBSTITUTO:</span>
            ${getNomeSobrenome(n[0].gestorSubstituto.nome)}` : ''}`,
      })),
    },
  };
}

export default getDadosGraficoNetwork;
